import { createContext, useContext } from 'react';
import type { ReactNode } from 'react';

import { eventService } from '../lib/EventService';

// Create a context for the event service
const EventContext = createContext(eventService);

interface EventProviderProps {
  children: ReactNode;
}

export function EventProvider({ children }: EventProviderProps) {
  return <EventContext.Provider value={eventService}>{children}</EventContext.Provider>;
}

// Hook to use event context
export function useEventContext() {
  return useContext(EventContext);
}
